<template>
  <div class="pdf-content">
    <div class="pdf-view" ref="needQrCode" v-show="showImage">
      <div class="pdf-l">
        <div class="p-l-top">
          <img src="../assets/images/pdf-top.png" />
        </div>
        <div class="p-l-center">
          <p class="plc-1">This is to certify that</p>
          <p class="plc-2">{{userName}}</p>
          <p class="plc-3">has completed the Bayer Cardiovascular Online Learning Module:</p>
          <p class="plc-4">Heart and kidney protection in CKD associated with type 2 diabetes: An introduction to the nonsteroidal MRA, finerenone </p>
          <div class="plc-5">
            <div>
              <p>Completion <br/>date:</p>
              <p>{{dateTime}}</p>
            </div>
            <div>
              <p>Module <br/>duration:</p>
              <p>40 minutes</p>
            </div>
            <div>
              <p>Number of ADEA <br/>CPD points allocated:</p>
              <p>1</p>
            </div>
          </div>
        </div>
        <div class="p-l-bottom">
          <div>
            <p>This module has been developed and funded by Bayer</p>
            <p>Bayer Inc. All rights reserved. Bayer Australia Ltd. ABN 22 000 138 714, 875 Pacific Highway, Pymble, NSW 2073. ® Registered trademark of the Bayer Group, Germany. PP-KER-AU-0305-02. SSW. KER-005007-03. Date of preparation: April 2026.</p>
          </div>
          <div>
            <img src="../assets/images/p5-6/5-6-4.png" />
          </div>
        </div>
      </div>
      <div class="pdf-r">
        <img src="../assets/images/pdf-right.png" />
      </div>
    </div>
    <img class="certificate-image" v-if="imageSaveUrl" :src="imageSaveUrl" />
    <div v-if="imageSaveUrl" @click="imageSaveUrl=''" class="show-certificate-img"><span>close</span></div>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import html2canvas from "html2canvas";
import JsPDF from 'jspdf';
import moment from 'moment';
export default {
  name: "ExportPDF",
  props:{
    'selected':{
      type:String,
      default:'-',
    },
    'required':{
      type:String,
      default:"false"
    }
  },
  data(){
    return {
      showImage: false,
      imageSaveUrl: "",
      userName: "",
      dateTime: ""
    }
  },
  computed:{

  },
  created() {

  },
  methods:{
    createImage(userName) {
      this.showImage = true;
      this.dateTime = moment().format('DD/MM/YYYY');
      this.userName = userName;
      this.imageSaveUrl = "";
      this.showInviteRegist = true;
      let _this = this;
      setTimeout(() => {
        (window.html2canvas || html2canvas)(_this.$refs.needQrCode,{
          useCORS: true,
          scale: 3
        }).then(canvas => {
          let dataURL = canvas.toDataURL("image/png");
          //var pdf = new JsPDF('landscape', 'pt', [849, 670]);
          var pdf = new JsPDF({
            orientation: 'landscape', // 横向（等价于原第一个参数）
            unit: 'pt',               // 单位pt（保留）
            format: [849, 670],       // 自定义尺寸（保留）
            compress: true            // 开启PDF流压缩（关键！）
          });
        	pdf.addImage(dataURL, 'PNG', 0, 0, 849, 670);

          const isIOS = /(iPhone|iPod|iPad)/i.test(navigator.userAgent);
          const isAndroid = /Android/i.test(navigator.userAgent);
          const blob = pdf.output('blob');

          if (isIOS) {
            const blobUrl = URL.createObjectURL(blob);
            window.location.href = blobUrl;

          } else if (isAndroid) {
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'certificate.pdf';
            a.click();
            setTimeout(() => URL.revokeObjectURL(url), 200);
          } else {
            pdf.save('certificate.pdf');
          }

          _this.showImage = false;
        });
      },1000)
    },
  }
}
</script>

<style lang="less" scoped>
.pdf-content {
  position:fixed;
  width:100%;
  top:0px;
  left:0px;
  background-color: rgb(48 49 51 / 68%);
}
.pdf-view {
  left:0px;
  top:-2300px;
  width: 849px;
  padding: 20px;
  background-color:#FFF;
  position:absolute;
  .pdf-l {
    width:531px;
    float:left;
    .p-l-top {
      float:left;
      width:100%;
      img {
        width:100%;
      }
    }
    .p-l-center {
      float:left;
      width:100%;
      padding: 20px 20px 10px 20px;
      p {
        width:100%;
        float:left;
      }
      .plc-1 {
        color:#D41F32;
        font-size:24px;
        margin-bottom: 10px;
        border-bottom:1px solid #000;
        padding-bottom: 15px;
      }
      .plc-2 {
        color:#000000;
        font-size:24px;
        line-height: 60px;
        font-weight:bold;
      }
      .plc-3 {
        color:#000000;
        font-size:14px;
        line-height: 22px;
        margin-bottom:10px;
      }
      .plc-4 {
        color:#000000;
        font-size:14px;
        line-height: 22px;
        font-weight:bold;
      }
      .plc-5 {
        float:left;
        width:100%;
        padding: 30px 0px;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        div {
          flex: 1;
          p {
            font-size:14px;
            line-height:22px;
          }
          p:nth-child(1) {
            color:#D41F32;
          }
          p:nth-child(2) {
            color:#000000;
          }
        }
        div:nth-child(1) {
          float:left;
        }
        div:nth-child(2) {
          float:right;
        }
      }
    }
    .p-l-bottom {
      float:left;
      width:100%;
      padding:0px 20px;
      display:flex;
      justify-content: center;
      align-items: center;
      div {
        p:nth-child(1) {
          margin-bottom: 10px;
        }
        img {
          width: 100%;
        }
      }
      div:nth-child(1) {
        font-size:8px;
        line-height:15px;
        color:#060606;
        width: 60%;
        padding-right: 14px;
      }
      div:nth-child(2) {
        width: 40%;
      }
    }
  }
  .pdf-r {
    width:258px;
    float:right;
    img {
      width:100%;
    }
  }
}
.certificate-image {
  width: calc(100vw - 40px);
  float:left;
  margin-top:20px;
  margin-left:20px;
  margin-bottom: 20px;
}
.show-certificate-img {
  float:left;
  width:100%;
  margin-bottom:20px;
  span {
    width: 80px;
    text-align: center;
    background-color: #FFF;
    border-radius: 5px;
    padding: 5px 10px;
    display: block;
    margin: 0 auto;
    font-size:16px;
  }
}
</style>
